import React from 'react';
import 'react-h5-audio-player/lib/styles.css';
import SGCommonPage from '../../../components/SGCommonPage';


function SukhmanaSahib() {
    return (
        <div>
            <SGCommonPage title="Sukhmana Sahib" apiName="sukhmana-sahib" audioName="sukhmana_sahib" tlPage="19" /> 
        </div>
    )
}

export default SukhmanaSahib